const MenuCrm = {
    Nombre: "CRM",
    Icono: "fas fa-chart-network",
    Permiso: 'CLAVECRM',
    Router: "",
    Parametros: {sFiltros:'NO'},
    TipoBoton: 1,
    EsDeRoot: 0,
    SubMenus: [
        {
            Nombre: "Calendario",
            Icono: "fas fa-calendar-check",
            Permiso: 'CLAVECALENDARIO',
            Router: "calendario",
            Parametros: {sFiltros:'NO',pOrigen:'CRM',pRegresarBool:true},
            TipoBoton: 0,
            EsDeRoot: 0,
            SubApartados: [],
        },
        {
            Nombre: "Carta de Bienvenida",
            Icono: "far fa-file-alt",
            Permiso: 'CLAVECARTABIENVENIDA',
            Router: "cartaDeBienvenida",
            Parametros: {sFiltros:'NO',pOrigen:'CRM',pTipo:'Bienvenida'},
            TipoBoton: 0,
            EsDeRoot: 0,
            Apartados: [],
        },
        {
            Nombre: "Prospectos",
            Icono: "far fa-rings-wedding",
            Permiso: 'CLAVEPROSPECTOS',
            Router: "prospectos",
            Parametros: {sFiltros:'NO',pOrigen:'CRM'},
            TipoBoton: 0,
            EsDeRoot: 0,
            Apartados: [],
        },
        {
            Nombre: "Asignación",
            Icono: "far fa-glass-cheers",
            Permiso: 'CLAVEASIGNACION',
            Router: "asignacionPersonal",
            Parametros: {sFiltros:'NO',pOrigen:'CRM'},
            TipoBoton: 0,
            EsDeRoot: 0,
            Apartados: [],
        },
        {
            Nombre: "Encuestas",
            Icono: "far fa-file-certificate",
            Permiso: 'CLAVEENCUESTAS',
            Router: "encuesta",
            Parametros: {sFiltros:'NO',pOrigen:'CRM'},
            TipoBoton: 0,
            EsDeRoot: 0,
            Apartados: [],
        },
        {
            Nombre: "Config Seguimiento",
            Icono: "fas fa-ballot-check",
            Permiso: 'CLAVECONFIGSEGUIMIENTO',
            Router: "configSeguimiento",
            Parametros: {sFiltros:'NO', pOrigen:'CRM'},
            TipoBoton: 0,
            EsDeRoot: 0,
            Apartados: [],
        },
        {
            Nombre: "Mensaje de Encuesta",
            Icono: "fas fa-envelope-open-text",
            Permiso: 'CLAVEMENSAJEENCUESTA',
            Router: "cartaDeBienvenida",
            Parametros: {sFiltros:'NO',pOrigen:'CRM',pTipo:'Encuesta'},
            TipoBoton: 0,
            EsDeRoot: 0,
            Apartados: [],
        },
        {
            Nombre: "Condiciones Contrato",
            Icono: "fas fa-chalkboard-teacher",
            Permiso: 'CLAVECONDICIONESCONTRATO',
            Router: "condicioncontrato",
            Parametros: {sFiltros:'NO',pOrigen:'CRM'},
            TipoBoton: 0,
            EsDeRoot: 0,
            Apartados: [],
        },
        {
            Nombre: "Plan de Ventas",
            Icono: "fas fa-file-invoice-dollar",
            Permiso: 'CLAVEPLANDEVENTAS',
            Router: "planDeVentas",
            Parametros: {sFiltros:'NO'},
            TipoBoton: 0,
            EsDeRoot: 0,
            Apartados: [],
        },
        {
            Nombre: "Rendimiento Cotización",
            Icono: "fas fa-comments-alt-dollar",
            Permiso: 'CLAVEREDIMIENTOCOTIZACION',
            Router: "rendimientoCotizacion",
            Parametros: {sFiltros:'NO'},
            TipoBoton: 0,
            EsDeRoot: 0,
            Apartados: [],
        },
        /* {
            Nombre: "Rendimiento Seguimiento",
            Icono: "fas fa-watch-fitness",
            Permiso: 'CLAVERENDIMIENTOSEGUIMIENTO',
            Router: "cotzPendientes",
            Parametros: {sFiltros:'NO'},
            TipoBoton: 0,
            EsDeRoot: 0,
            Apartados: [],
        }, */
        {
            Nombre: "Rendimiento Eventos",
            Icono: "fas fa-watch-fitness",
            Permiso: 'CLAVERENDIMIENTOEVENTOS',
            Router: "rendimientoEvento",
            Parametros: {sFiltros:'NO', pOrigen:'CRM'},
            TipoBoton: 0,
            EsDeRoot: 0,
            Apartados: [],
        },
        {
            Nombre: "Rendimiento Encuestas",
            Icono: "far fa-file-certificate",
            Permiso: 'CLAVERENDIMIENTOENCUESTAS',
            Router: "rendimientoEncuesta",
            Parametros: {sFiltros:'NO'},
            TipoBoton: 0,
            EsDeRoot: 0,
            Apartados: [],
        },
    ],
};

const MenuFinanzas = {
    Nombre: 'Finanzas',
    Icono: 'fas fa-usd-square',
    Permiso: 'CLAVEFINANZAS',
    Router: '',
    Parametros: {sFiltros:'NO'},
    TipoBoton: 0,
    EsDeRoot: 0,
    SubMenus: [
        {
            Nombre: 'Facturación',
            Icono: "",
            Permiso: 'CLAVEFACTURACION',
            Router: 'TipoFamiliar',
            Parametros: {sFiltros:'NO'},
            TipoBoton: 1,
            EsDeRoot: 0,
            Apartados: [
                {
                    Nombre: 'Cotz Pendientes',
                    Icono: "fas fa-file-contract",
                    Permiso: 'CLAVECOTZPENDIENTES',
                    Router: 'cotzPendientes',
                    Parametros: {sFiltros:'NO',pOrigen:'Finanzas',pLugar:'cotzpendientes'},
                    TipoBoton: 0,
                    EsDeRoot: 0,
                    SubApartados: []
                },
                /* {
                    Nombre: 'Cotz Facturadas',
                    Icono: "fas fa-file-alt",
                    Permiso: 'CLAVECOTZFACTURADAS',
                    Router: 'cotzfacturadas',
                    Parametros: {sFiltros:'NO',pOrigen:'Finanzas',pLugar:'cotzfacturadas'},
                    TipoBoton: 0,
                    EsDeRoot: 0,
                    SubApartados: []
                }, */
                /* {
                    Nombre: 'Cotz Finalizadas',
                    Icono: "fas fa-file-check",
                    Permiso: 'CLAVECOTZFINALIZADAS',
                    Router: 'cotzPendientes',
                    Parametros: {sFiltros:'NO',pOrigen:'Finanzas',pLugar:'cotzfinalizadas'},
                    TipoBoton: 0,
                    EsDeRoot: 0,
                    SubApartados: []
                }, */
                /* {
                    Nombre: 'Facturas Libres',
                    Icono: "fas fa-file-invoice",
                    Permiso: 'CLAVEFACTURASLIBRES',
                    Router: 'factura',
                    Parametros: {sFiltros:'NO',pOrigen:'Finanzas',pLugar:'FacturaLibre'},
                    TipoBoton: 0,
                    EsDeRoot: 0,
                    SubApartados: []
                }, */
                {
                    Nombre: 'Facturas',
                    Icono: "fas fa-file-invoice-dollar",
                    Permiso: 'CLAVEFACTURAS',
                    Router: 'facturaTimbrada',
                    Parametros: {sFiltros:'NO',pOrigen:'Finanzas'},
                    TipoBoton: 0,
                    EsDeRoot: 0,
                    SubApartados: []
                },
                {
                    Nombre: 'Nota de Crédito',
                    Icono: "fad fa-file-invoice-dollar",
                    Permiso: 'CLAVENOTASDECREDITO',
                    Router: 'notacredito',
                    Parametros: {sFiltros:'NO',pOrigen:'Finanzas'},
                    TipoBoton: 0,
                    EsDeRoot: 0,
                    SubApartados: []
                },
                {
                    Nombre: 'Nota de Pago',
                    Icono: "fas fa-receipt",
                    Permiso: 'CLAVENOTASDEPAGO',
                    Router: 'notapago',
                    Parametros: {sFiltros:'NO',pOrigen:'Finanzas'},
                    TipoBoton: 0,
                    EsDeRoot: 0,
                    SubApartados: []
                },
                {
                    Nombre: 'Cuentas Por Pagar',
                    Icono: "fas fa-donate",
                    Permiso: 'CLAVECUENTASPORPAGAR',
                    Router: 'cuentaporpagar',
                    Parametros: {sFiltros:'NO',pOrigen:'Finanzas'},
                    TipoBoton: 0,
                    EsDeRoot: 0,
                    Apartados: []
                },
                {
                    Nombre: 'Cuentas Por Cobrar',
                    Icono: "fas fa-hand-holding-usd",
                    Permiso: 'CLAVECUENTASPORCOBRAR',
                    Router: 'cuentaporcobrar',
                    Parametros: {sFiltros:'NO',pOrigen:'Finanzas'},
                    TipoBoton: 0,
                    EsDeRoot: 0,
                    Apartados: []
                },
                {
                    Nombre: 'Carta Porte',
                    Icono: "fas fa-truck",
                    Permiso: 'CLAVECARTAPORTE',
                    Router: 'cartaporte',
                    Parametros: {sFiltros:'NO',pOrigen:'Finanzas'},
                    TipoBoton: 0,
                    EsDeRoot: 0,
                    Apartados: []
                },
            ]
        },
        {
            Nombre: 'Conf. Carta Porte',
            Icono: "",
            Permiso: 'CLAVECONFCARTAPORTE',
            Router: 'TipoFamiliar',
            Parametros: {sFiltros:'NO'},
            TipoBoton: 1,
            EsDeRoot: 0,
            Apartados: [
                {
                    Nombre: 'Productos y Servicios',
                    Icono: "fas fa-tags",
                    Permiso: 'CLAVECPPRODUCTOSYSERVICIOS',
                    Router: 'cpproductoservicio',
                    Parametros: {sFiltros:'NO',pOrigen:'Finanzas'},
                    TipoBoton: 0,
                    EsDeRoot: 0,
                    SubApartados: []
                },
                {
                    Nombre: 'País',
                    Icono: "fas fa-globe-americas",
                    Permiso: 'CLAVECPPAIS',
                    Router: 'cppais',
                    Parametros: {sFiltros:'NO',pOrigen:'Finanzas'},
                    TipoBoton: 0,
                    EsDeRoot: 0,
                    SubApartados: []
                },
                {
                    Nombre: 'Estado',
                    Icono: "fas fa-map",
                    Permiso: 'CLAVECPESTADO',
                    Router: 'cpestado',
                    Parametros: {sFiltros:'NO',pOrigen:'Finanzas'},
                    TipoBoton: 0,
                    EsDeRoot: 0,
                    SubApartados: []
                },
                {
                    Nombre: 'Municipio',
                    Icono: "fas fa-university",
                    Permiso: 'CLAVECPMUNICIPIO',
                    Router: 'cpmunicipio',
                    Parametros: {sFiltros:'NO',pOrigen:'Finanzas'},
                    TipoBoton: 0,
                    EsDeRoot: 0,
                    SubApartados: []
                },
                {
                    Nombre: 'Colonia',
                    Icono: "fas fa-house",
                    Permiso: 'CLAVECPCOLONIA',
                    Router: 'cpcolonia',
                    Parametros: {sFiltros:'NO',pOrigen:'Finanzas'},
                    TipoBoton: 0,
                    EsDeRoot: 0,
                    SubApartados: []
                },
                {
                    Nombre: 'Localidad',
                    Icono: "fas fa-street-view",
                    Permiso: 'CLAVECPLOCALIDAD',
                    Router: 'cplocalidad',
                    Parametros: {sFiltros:'NO',pOrigen:'Finanzas'},
                    TipoBoton: 0,
                    EsDeRoot: 0,
                    SubApartados: []
                },
                {
                    Nombre: 'Destinos',
                    Icono: "fas fa-map-marker-alt",
                    Permiso: 'CLAVECPDESTINOS',
                    Router: 'cpdestinos',
                    Parametros: {sFiltros:'NO',pOrigen:'Finanzas'},
                    TipoBoton: 0,
                    EsDeRoot: 0,
                    SubApartados: []
                },
                {
                    Nombre: 'Clave Transporte',
                    Icono: "fas fa-tag",
                    Permiso: 'CLAVECPCLAVETRANSPORTE',
                    Router: 'cpclavetransporte',
                    Parametros: {sFiltros:'NO',pOrigen:'Finanzas'},
                    TipoBoton: 0,
                    EsDeRoot: 0,
                    SubApartados: []
                },
                {
                    Nombre: 'Clave Unidad Peso',
                    Icono: "fas fa-industry",
                    Permiso: 'CLAVECPCLAVEUNIDADPESO',
                    Router: 'cpclaveunidadpeso',
                    Parametros: {sFiltros:'NO',pOrigen:'Finanzas'},
                    TipoBoton: 0,
                    EsDeRoot: 0,
                    SubApartados: []
                },
                {
                    Nombre: 'Configuración Vehicular',
                    Icono: "fas fa-gears",
                    Permiso: 'CLAVECPCONFIGURACIONVEHICULAR',
                    Router: 'cpconfigautotransporte',
                    Parametros: {sFiltros:'NO',pOrigen:'Finanzas'},
                    TipoBoton: 0,
                    EsDeRoot: 0,
                    SubApartados: []
                },
                {
                    Nombre: 'Figura Transporte',
                    Icono: "fas fa-user-tie",
                    Permiso: 'CLAVECPFIGURATRANSPORTE',
                    Router: 'cpfiguratransporte',
                    Parametros: {sFiltros:'NO',pOrigen:'Finanzas'},
                    TipoBoton: 0,
                    EsDeRoot: 0,
                    SubApartados: []
                },
                {
                    Nombre: 'Material Peligroso',
                    Icono: "fas fa-warning",
                    Permiso: 'CLAVECPMATERIALPELIGROSO',
                    Router: 'cpmaterialpeligroso',
                    Parametros: {sFiltros:'NO',pOrigen:'Finanzas'},
                    TipoBoton: 0,
                    EsDeRoot: 0,
                    SubApartados: []
                },
                {
                    Nombre: 'Nacionalidad',
                    Icono: "fas fa-flag",
                    Permiso: 'CLAVECPNACIONALIDAD',
                    Router: 'cpnacionalidad',
                    Parametros: {sFiltros:'NO',pOrigen:'Finanzas'},
                    TipoBoton: 0,
                    EsDeRoot: 0,
                    SubApartados: []
                },
                {
                    Nombre: 'Parte Transporte',
                    Icono: "fas fa-truck",
                    Permiso: 'CLAVECPPARTETRANSPORTE',
                    Router: 'cppartetransporte',
                    Parametros: {sFiltros:'NO',pOrigen:'Finanzas'},
                    TipoBoton: 0,
                    EsDeRoot: 0,
                    SubApartados: []
                },
                {
                    Nombre: 'Permiso SCT',
                    Icono: "fas fa-certificate",
                    Permiso: 'CLAVECPPERMISOSCT',
                    Router: 'cppermisosct',
                    Parametros: {sFiltros:'NO',pOrigen:'Finanzas'},
                    TipoBoton: 0,
                    EsDeRoot: 0,
                    SubApartados: []
                },
                {
                    Nombre: 'Sub Tipo Remolque',
                    Icono: "fas fa-wrench",
                    Permiso: 'CLAVECPSUBTIPOREMOLQUE',
                    Router: 'cpsubtiporemolque',
                    Parametros: {sFiltros:'NO',pOrigen:'Finanzas'},
                    TipoBoton: 0,
                    EsDeRoot: 0,
                    SubApartados: []
                },
                {
                    Nombre: 'Tipo Embalaje',
                    Icono: "fas fa-tasks",
                    Permiso: 'CLAVECPTIPOEMBALAJE',
                    Router: 'cptipoembalaje',
                    Parametros: {sFiltros:'NO',pOrigen:'Finanzas'},
                    TipoBoton: 0,
                    EsDeRoot: 0,
                    SubApartados: []
                },
                {
                    Nombre: 'Bandera Unidad',
                    Icono: "fas fa-pencil-square-o",
                    Permiso: 'CLAVECPBANDERAUNIDAD',
                    Router: 'cpbanderaunidad',
                    Parametros: {sFiltros:'NO',pOrigen:'Finanzas'},
                    TipoBoton: 0,
                    EsDeRoot: 0,
                    SubApartados: []
                },
                {
                    Nombre: 'Choferes',
                    Icono: "fas fa-drivers-license",
                    Permiso: 'CLAVECPCHOFERES',
                    Router: 'cpchofer',
                    Parametros: {sFiltros:'NO',pOrigen:'Finanzas'},
                    TipoBoton: 0,
                    EsDeRoot: 0,
                    SubApartados: []
                },
                {
                    Nombre: 'Vehículos',
                    Icono: "fas fa-car",
                    Permiso: 'CLAVECPVEHICULOS',
                    Router: 'cpvehiculo',
                    Parametros: {sFiltros:'NO',pOrigen:'Finanzas'},
                    TipoBoton: 0,
                    EsDeRoot: 0,
                    SubApartados: []
                },
            ]
        },
        {
            Nombre: 'Configuración',
            Icono: "",
            Permiso: 'CLAVEFINANZASCONFIGURACION',
            Router: 'TipoFamiliar',
            Parametros: {sFiltros:'NO'},
            TipoBoton: 1,
            EsDeRoot: 0,
            Apartados: [
                {
                    Nombre: 'Régimen Fiscal',
                    Icono: "fas fa-user-tie",
                    Permiso: 'CLAVEREGIMENFISCAL',
                    Router: 'regimenfiscal',
                    Parametros: {sFiltros:'NO',pOrigen:'Finanzas'},
                    TipoBoton: 0,
                    EsDeRoot: 0,
                    SubApartados: []
                },
                {
                    Nombre: 'Uso de CFDI',
                    Icono: "fas fa-file",
                    Permiso: 'CLAVEUSODECFDI',
                    Router: 'usocfdi',
                    Parametros: {sFiltros:'NO',pOrigen:'Finanzas'},
                    TipoBoton: 0,
                    EsDeRoot: 0,
                    SubApartados: []
                },
                {
                    Nombre: 'Productos y Servicios',
                    Icono: "far fa-concierge-bell",
                    Permiso: 'CLAVEPRODUCTOSYSERVICIOS',
                    Router: 'claveprodserv',
                    Parametros: {sFiltros:'NO',pOrigen:'Finanzas'},
                    TipoBoton: 0,
                    EsDeRoot: 0,
                    SubApartados: []
                },
                {
                    Nombre: 'Métodos de Pago',
                    Icono: "fas fa-layer-plus",
                    Permiso: 'CLAVEMETODOSDEPAGO',
                    Router: 'metodopago',
                    Parametros: {sFiltros:'NO',pOrigen:'Finanzas'},
                    TipoBoton: 0,
                    EsDeRoot: 0,
                    SubApartados: []
                },
                {
                    Nombre: 'Formas de Pago',
                    Icono: "fal fa-credit-card",
                    Permiso: 'CLAVEFORMASDEPAGO',
                    Router: 'formapago',
                    Parametros: {sFiltros:'NO',pOrigen:'Finanzas'},
                    TipoBoton: 0,
                    EsDeRoot: 0,
                    SubApartados: []
                },
                {
                    Nombre: 'Unidades de Medida',
                    Icono: "fas fa-balance-scale",
                    Permiso: 'CLAVEUNIDADESDEMEDIDA',
                    Router: 'unidades',
                    Parametros: {sFiltros:'NO',pOrigen:'Finanzas'},
                    TipoBoton: 0,
                    EsDeRoot: 0,
                    SubApartados: []
                },
                {
                    Nombre: 'Monedas',
                    Icono: "far fa-coins",
                    Permiso: 'CLAVEMONEDAS',
                    Router: 'moneda',
                    Parametros: {sFiltros:'NO',pOrigen:'Finanzas'},
                    TipoBoton: 0,
                    EsDeRoot: 0,
                    SubApartados: []
                },
                {
                    Nombre: 'Tipos de Relación',
                    Icono: "fa fa-table",
                    Permiso: 'CLAVETIPOSDERELACION',
                    Router: 'tiporelacioncfdi',
                    Parametros: {sFiltros:'NO',pOrigen:'Finanzas'},
                    TipoBoton: 0,
                    EsDeRoot: 0,
                    SubApartados: []
                },
                {
                    Nombre: 'Bancos',
                    Icono: "far fa-university",
                    Permiso: 'CLAVEBANCOS',
                    Router: 'bancos',
                    Parametros: {sFiltros:'NO',pOrigen:'Finanzas'},
                    TipoBoton: 0,
                    EsDeRoot: 0,
                    SubApartados: []
                },
                {
                    Nombre: 'Objeto Impuesto',
                    Icono: "fas fa-file",
                    Permiso: 'CLAVEOBJECTOIMPUESTO',
                    Router: 'objetoimpuesto',
                    Parametros: {sFiltros:'NO',pOrigen:'Finanzas'},
                    TipoBoton: 0,
                    EsDeRoot: 0,
                    Apartados: []
                },
                {
                    Nombre: 'Impuestos',
                    Icono: "fas fa-donate",
                    Permiso: 'CLAVEIMPUESTOS',
                    Router: 'impuesto',
                    Parametros: {sFiltros:'NO',pOrigen:'Finanzas'},
                    TipoBoton: 0,
                    EsDeRoot: 0,
                    Apartados: []
                },
                {
                    Nombre: 'Conceptos F y M',
                    Icono: "fas fa-hand-holding-usd",
                    Permiso: 'CLAVECONCEPTOSFYM',
                    Router: 'conceptosfym',
                    Parametros: {sFiltros:'NO',pOrigen:'Finanzas'},
                    TipoBoton: 0,
                    EsDeRoot: 0,
                    Apartados: []
                },
            ]
        },
        {
            Nombre: 'Rendimiento',
            Icono: "",
            Permiso: 'CLAVERENDIMIENTO',
            Router: 'TipoFamiliar',
            Parametros: {sFiltros:'NO'},
            TipoBoton: 1,
            EsDeRoot: 0,
            Apartados: [
                {
                    Nombre: "Indicador de Resultados",
                    Icono: "fas fa-user-chart",
                    Permiso: 'CLAVEINDICADORDERESULTADOS',
                    Router: "indicadorresultados",
                    Parametros: {sFiltros:'NO'},
                    TipoBoton: 0,
                    EsDeRoot: 0,
                    Apartados: [],
                },
                {
                    Nombre: "Rep. Preventa",
                    Icono: "far fa-chart-line",
                    Permiso: 'CLAVEREPPREVENTA',
                    Router: "reportepreventa",
                    Parametros: {sFiltros:'NO'},
                    TipoBoton: 0,
                    EsDeRoot: 0,
                    Apartados: [],
                },
                {
                    Nombre: "Rep. Ventas",
                    Icono: "fal fa-analytics",
                    Permiso: 'CLAVEREPVENTAS',
                    Router: "reporteventa",
                    Parametros: {sFiltros:'NO'},
                    TipoBoton: 0,
                    EsDeRoot: 0,
                    Apartados: [],
                },
                {
                    Nombre: "Gráficas de cuentas",
                    Icono: "fas fa-chart-bar",
                    Permiso: 'CLAVEREPVENTAS',
                    Router: "graficaCuentas",
                    Parametros: {sFiltros:'NO', pOrigen:'CRM'},
                    TipoBoton: 0,
                    EsDeRoot: 0,
                    Apartados: [],
                },
                /* {
                    Nombre: "Facturación",
                    Icono: "fas fa-badge-dollar",
                    Permiso: 'CLAVERENDIMIENTOFACTURACION',
                    Router: "cotzPendientes",
                    Parametros: {sFiltros:'NO'},
                    TipoBoton: 0,
                    EsDeRoot: 0,
                    Apartados: [],
                }, */
            ]
        }
    ]
};

const MenuAlmacen = {
    Nombre: 'Almacen',
    Icono: 'fas fa-box',
    Permiso: 'CLAVEALMACEN',
    Router: 'panelSubMenus',
    Parametros: {sFiltros:'NO'},
    TipoBoton: 1,
    EsDeRoot: 0,
    SubMenus: [
        {
            Nombre: 'Requisición',
            Icono: "fas fa-money-check-edit",
            Permiso: 'CLAVEREQUISICION',
            Router: 'Requisicion',
            Parametros: {sFiltros:'NO'},
            TipoBoton: 0,
            EsDeRoot: 0,
            Apartados: []
        },
        {
            Nombre: 'Ord. de Compras',
            Icono: "fas fa-money-check-edit-alt",
            Permiso: 'CLAVEORDENDECOMPRAS',
            Router: 'OrdenCompra',
            Parametros: {sFiltros:'NO'},
            TipoBoton: 0,
            EsDeRoot: 0,
            Apartados: []
        },
        {
            Nombre: 'Movimientos',
            Icono: "far fa-money-check",
            Permiso: 'CLAVEMOVIMIENTOS',
            Router: 'Entrada',
            Parametros: {sFiltros:'NO'},
            TipoBoton: 0,
            EsDeRoot: 0,
            Apartados: []
        },
        {
            Nombre: 'Categoría Productos',
            Icono: "far fa-project-diagram",
            Permiso: 'CLAVECATEGORIAPRODUCTOS',
            Router: 'ProductoCategoria',
            Parametros: {sFiltros:'NO'},
            TipoBoton: 0,
            EsDeRoot: 0,
            SubApartados: []
        },
        {
            Nombre: 'Proveedores',
            Icono: "fas fa-briefcase",
            Permiso: 'CLAVEPROVEEDORES',
            Router: 'Proveedor',
            Parametros: {sFiltros:'NO'},
            TipoBoton: 0,
            EsDeRoot: 0,
            SubApartados: []
        },
        {
            Nombre: 'Unidad',
            Icono: "fas fa-balance-scale",
            Permiso: 'CLAVEUNIDAD',
            Router: 'UnidadMaterial',
            Parametros: {sFiltros:'NO'},
            TipoBoton: 0,
            EsDeRoot: 0,
            SubApartados: []
        },
        {
            Nombre: 'Materiales',
            Icono: "fad fa-pencil-ruler",
            Permiso: 'CLAVEMATERIALES',
            Router: 'material',
            Parametros: {sFiltros:'NO'},
            TipoBoton: 0,
            EsDeRoot: 0,
            SubApartados: []
        },
        {
            Nombre: 'Salida Almacen',
            Icono: "fas fa-boxes",
            Permiso: 'CLAVESALIDAALMACEN',
            Router: 'solicitudSalida',
            Parametros: {sFiltros:'NO',pOrigen:'Almacen'},
            TipoBoton: 0,
            EsDeRoot: 0,
            SubApartados: []
        },
        {
            Nombre: 'Solicitudes',
            Icono: "far fa-clipboard",
            Permiso: 'CLAVESOLICITUDES',
            Router: 'solicitudalmacen',
            Parametros: {sFiltros:'NO',pOrigen:'Almacen'},
            TipoBoton: 0,
            EsDeRoot: 0,
            SubApartados: []
        },
        {
            Nombre: 'Inventario',
            Icono: "fas fa-clipboard-check",
            Permiso: 'CLAVEINVENTARIO',
            Router: 'inventario',
            Parametros: {sFiltros:'NO',pOrigen:'Almacen'},
            TipoBoton: 0,
            EsDeRoot: 0,
            SubApartados: []
        },
        {
            Nombre: 'Productos',
            Icono: "fas fa-gift-card",
            Permiso: 'CLAVEPRODUCTOS',
            Router: 'Producto',
            Parametros: {sFiltros:'NO'},
            TipoBoton: 0,
            EsDeRoot: 0,
            SubApartados: []
        },
    ]
};

const MenuConfig =
{
    Nombre: 'Configuración',
    Icono: 'fas fa-cog',
    Permiso: 'CLAVECONFIGURACION',
    Router: '',
    Parametros: {sFiltros:'NO'},
    TipoBoton: 0,
    EsDeRoot: 0,
    SubMenus: [
        {
            Nombre: 'Root',
            Icono: "",
            Permiso: 'CLAVEROOT',
            Router: 'panelSubMenus',
            Parametros: {},
            TipoBoton: 1,
            EsDeRoot: 1,
            Apartados: [
                {
                    Nombre: 'Menus',
                    Icono: "far fa-bars",
                    Permiso: 'CLAVEMENUS',
                    Router: 'paneles',
                    Parametros: {sFiltros:'NO', pOrigen:'Configuración'},
                    TipoBoton: 0,
                    EsDeRoot: 1,
                    SubApartados: []
                },
                {
                    Nombre: 'Permisos',
                    Icono: "fas fa-user-lock",
                    Permiso: 'CLAVEPERMISOS',
                    Router: 'permisos',
                    Parametros: {sFiltros:'NO', pOrigen:'Configuración'},
                    TipoBoton: 0,
                    EsDeRoot: 1,
                    SubApartados: []
                },
                {
                    Nombre: 'Empresas',
                    Icono: "far fa-building",
                    Permiso: 'CLAVEEMPRESA',
                    Router: 'cuentaEmpresa',
                    Parametros: {sFiltros:'NO', pOrigen:'Configuración'},
                    TipoBoton: 0,
                    EsDeRoot: 1,
                    SubApartados: []
                },
                {
                    Nombre: 'Timbrado Rutas',
                    Icono: "far fa-file-certificate",
                    Permiso: 'CLAVETIMBRADORUTAS',
                    Router: 'timbradoRutaBase',
                    Parametros: {sFiltros:'NO', pOrigen:'Configuración'},
                    TipoBoton: 0,
                    EsDeRoot: 1,
                    SubApartados: []
                },
                {
                    Nombre: 'Módulos Sistema',
                    Icono: "far fa-cubes",
                    Permiso: 'CLAVEMODULOSSISTEMA',
                    Router: 'modulosSistema',
                    Parametros: {sFiltros:'NO', pOrigen:'Configuración'},
                    TipoBoton: 0,
                    EsDeRoot: 1,
                    SubApartados: []
                },
                {
                    Nombre: 'Paquetes Sistema',
                    Icono: "far fa-box-alt",
                    Permiso: 'CLAVEPAQUETESISTEMA',
                    Router: 'paquetesSistema',
                    Parametros: {sFiltros:'NO', pOrigen:'Configuración'},
                    TipoBoton: 0,
                    EsDeRoot: 1,
                    SubApartados: []
                },
                {
                    Nombre: 'Asignar Paquetes Empresa',
                    Icono: "far fa-hand-holding-box",
                    Permiso: 'CLAVEROOT',
                    Router: 'paquetesSistemaEmpresa',
                    Parametros: {sFiltros:'NO', pOrigen:'Configuración'},
                    TipoBoton: 0,
                    EsDeRoot: 1,
                    SubApartados: []
                },
                {
                    Nombre: 'Notificaciones',
                    Icono: "far fa-bell",
                    Permiso: 'CLAVEMENUS',
                    Router: 'notificacionesConfig',
                    Parametros: {sFiltros:'NO', pOrigen:'Configuración'},
                    TipoBoton: 0,
                    EsDeRoot: 1,
                    SubApartados: []
                },
                // SIMULACION DE NOTIFICACIONES, RETIRAR DESPUES
                // {
                //     Nombre: 'Ver Notificaciones',
                //     Icono: "far fa-bell",
                //     Permiso: 'CLAVEMENUS',
                //     Router: 'notificacionesConfig',
                //     Parametros: {sFiltros:'NO', pOrigen:'Configuración'},
                //     TipoBoton: 0,
                //     EsDeRoot: 1,
                //     SubApartados: []
                // },
            ]
        },
        {
            Nombre: 'Empresa',
            Icono: "",
            Permiso: 'CLAVEEMPRESA',
            Router: 'panelSubMenus',
            Parametros: {},
            TipoBoton: 1,
            EsDeRoot: 0,
            Apartados: [
                {
                    Nombre: 'Mi Empresa',
                    Icono: "fas fa-building",
                    Permiso: 'CLAVEMIEMPRESA',
                    Router: 'empresa',
                    Parametros: {sFiltros:'NO', pOrigen:'Configuración'},
                    TipoBoton: 0,
                    EsDeRoot: 0,
                    SubApartados: []
                },
                {
                    Nombre: 'Personal',
                    Icono: "fas fa-user-cog",
                    Permiso: 'CLAVEEMPLEADOS',
                    Router: 'empleados',
                    Parametros: {sFiltros:'NO', pOrigen:'Configuración'},
                    TipoBoton: 0,
                    EsDeRoot: 0,
                    SubApartados: []
                },
                {
                    Nombre: 'Personal Hoteles',
                    Icono: "fas fa-user-tag",
                    Permiso: 'CLAVEPERSONALHOTELES',
                    Router: 'empleadosB',
                    Parametros: {sFiltros:'NO', pOrigen:'Configuración'},
                    TipoBoton: 0,
                    EsDeRoot: 0,
                    SubApartados: []
                },
                {
                    Nombre: 'Perfiles',
                    Icono: "fas fa-poll-people",
                    Permiso: 'CLAVEPERFILES',
                    Router: 'perfiles',
                    Parametros: {sFiltros:'NO', pOrigen:'Configuración'},
                    TipoBoton: 0,
                    EsDeRoot: 0,
                    SubApartados: []
                },
                {
                    Nombre: "Correo Electrónico",
                    Icono: "far fa-mailbox",
                    Permiso: 'CLAVECORREOELECTRONICO',
                    Router: "correo",
                    Parametros: {sFiltros:'NO', pOrigen:'Configuración'},
                    TipoBoton: 0,
                    EsDeRoot: 0,
                    SubApartados: [],
                },
            ]
        },
        {
            Nombre: 'Administración',
            Icono: "",
            Permiso: 'CLAVEADMINISTRACION',
            Router: 'panelSubMenus',
            Parametros: {},
            TipoBoton: 1,
            EsDeRoot: 0,
            Apartados: [
                {
                    Nombre: 'Folios',
                    Icono: "fas fa-scroll",
                    Permiso: 'CLAVEFOLIOS',
                    Router: 'folio',
                    Parametros: {sFiltros:'NO', pOrigen:'Configuración'},
                    TipoBoton: 0,
                    EsDeRoot: 0,
                    SubApartados: []
                },
                {
                    Nombre: 'Departamentos',
                    Icono: "fas fa-network-wired",
                    Permiso: 'CLAVEDEPARTAMENTOS',
                    Router: 'departamento',
                    Parametros: {sFiltros:'NO', pOrigen:'Configuración'},
                    TipoBoton: 0,
                    EsDeRoot: 0,
                    SubApartados: []
                },
                {
                    Nombre: 'Destinatario',
                    Icono: "fal fa-mail-bulk",
                    Permiso: 'CLAVEDESTINATARIO',
                    Router: 'destinatario',
                    Parametros: {sFiltros:'NO', pOrigen:'Configuración'},
                    TipoBoton: 0,
                    EsDeRoot: 0,
                    SubApartados: []
                },
                {
                    Nombre: 'Comisiones',
                    Icono: "far fa-percentage",
                    Permiso: 'CLAVECOMISIONES',
                    Router: 'comision',
                    Parametros: {sFiltros:'NO', pOrigen:'Configuración'},
                    TipoBoton: 0,
                    EsDeRoot: 0,
                    SubApartados: []
                },
                {
                    Nombre: 'Hotel/Empresa',
                    Icono: "fas fa-building",
                    Permiso: 'CLAVEHOTELEMPRESA',
                    Router: 'hotelEmpresa',
                    Parametros: {sFiltros:'NO', pOrigen:'Configuración'},
                    TipoBoton: 0,
                    EsDeRoot: 0,
                    SubApartados: []
                },
                {
                    Nombre: 'Galeria',
                    Icono: "far fa-images",
                    Permiso: 'CLAVEGALERIA',
                    Router: 'categoriaGaleria',
                    Parametros: {sFiltros:'NO', pOrigen:'Configuración'},
                    TipoBoton: 0,
                    EsDeRoot: 0,
                    SubApartados: []
                },
                {
                    Nombre: 'Acciones',
                    Icono: "fas fa-money-check-edit",
                    Permiso: 'CLAVEACCIONES',
                    Router: 'accion',
                    Parametros: {sFiltros:'NO', pOrigen:'Configuración'},
                    TipoBoton: 0,
                    EsDeRoot: 0,
                    SubApartados: []
                },
                {
                    Nombre: 'Tipo de Evento',
                    Icono: "far fa-glass-cheers",
                    Permiso: 'CLAVETIPODEEVENTO',
                    Router: 'tipoEvento',
                    Parametros: {sFiltros:'NO', pOrigen:'Configuración'},
                    TipoBoton: 0,
                    EsDeRoot: 0,
                    SubApartados: []
                },
                {
                    Nombre: 'Tipos de Cancelación',
                    Icono: "fas fa-ban",
                    Permiso: 'CLAVETIPOSDECANCELACION',
                    Router: 'tipoDescarto',
                    Parametros: {sFiltros:'NO', pOrigen:'Configuración'},
                    TipoBoton: 0,
                    EsDeRoot: 0,
                    SubApartados: []
                },
                /* {
                    Nombre: 'Folios',
                    Icono: "fad fa-clipboard-list",
                    Permiso: 'CLAVETIPOFAM',
                    Router: 'TipoFamiliar',
                    Parametros: {sFiltros:'NO'},
                    TipoBoton: 0,
                    EsDeRoot: 0,
                    SubApartados: []
                }, */
            ]
        },        
    ]
};

const ConfigMenus = [
    MenuCrm,
    MenuFinanzas,
    MenuAlmacen,
    MenuConfig
];

export default {
    ConfigMenus,
}
